<template>
  <b-card no-body class="mb-1">
    <b-card-header
      role="tab"
      class="cursor-pointer d-flex justify-content-between align-items-center"
      @click="open = !open"
    >
      <div class="d-flex align-items-center flex-wrap">
        <span class="font-weight-bold">{{ item.recipient.name }}</span>
        <b-badge
          v-for="section in item.sections"
          :key="section.kind"
          :variant="`light-${kindVariant(section.kind)}`"
          class="ml-1"
        >
          {{ kindLabel(section.kind) }}
        </b-badge>
        <small class="text-muted ml-1">{{ item.itemsCount }} поз.</small>
      </div>
      <div class="d-flex align-items-center">
        <strong>{{ formatRub(item.total) }}</strong>
        <feather-icon :icon="open ? 'ChevronUpIcon' : 'ChevronDownIcon'" class="ml-1" />
      </div>
    </b-card-header>
    <b-collapse v-model="open">
      <b-card-body>
        <finance-payouts-kind-section
          v-for="section in item.sections"
          :key="section.kind"
          :section="section"
        />
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BCollapse, BBadge,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import { formatRub } from '@/views/finance/utils'
import FinancePayoutsKindSection from '@/views/finance/components/FinancePayoutsKindSection.vue'

const KIND_LABELS = { host: 'Ведущий', author: 'Автор', fixed: 'Фиксированная', extra: 'Прочее' }
const KIND_VARIANTS = { host: 'info', author: 'warning', fixed: 'secondary', extra: 'primary' }

export default {
  components: {
    BCard, BCardHeader, BCardBody, BCollapse, BBadge, FinancePayoutsKindSection,
  },
  props: {
    item: { type: Object, required: true },
  },
  setup() {
    const open = ref(false)
    const kindLabel = k => KIND_LABELS[k] || k
    const kindVariant = k => KIND_VARIANTS[k] || 'secondary'

    return {
      open, kindLabel, kindVariant, formatRub,
    }
  },
}
</script>
